import React from 'react';
import { SaludDoradaPage } from './pages/SaludDoradaPage';
export function App() {
  return <SaludDoradaPage data-id="element-0" />;
}